import React from "react";
import LibraryContainer from "./LibraryContainer";

const Library = (props) => {
  return (
      <LibraryContainer location={props.location} history={props.history} match={props.match}/>
  );
};

export default Library;
